<template>
    <div class="create-goods">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/user' }">用户列表</el-breadcrumb-item>
            <el-breadcrumb-item>编辑用户</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem; background-color: white">
            <el-form ref="form" :rules="rules" :model="form" label-width="180px">
                <el-form-item label="用户姓名" prop="name">
                    <el-col :span="8">
                        <el-input v-model="form.name"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="手机号" prop="name">
                    <el-col :span="8">
                        {{form.phone}}
                    </el-col>
                </el-form-item>
<!--                <el-form-item label="余额" prop="name">-->
<!--                    <el-col :span="8">-->
<!--                        <el-input v-model="form.balance"></el-input>-->
<!--                    </el-col>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="用户等级:" prop="level">-->
<!--                    <el-select v-model="form.level" placeholder="请选择">-->
<!--                        <el-option-->
<!--                                v-for="item in 100"-->
<!--                                :key="item"-->
<!--                                :label="item"-->
<!--                                :value="item">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="用户激活" prop="onSale">-->
<!--                    <el-col :span="8">-->
<!--                        <el-switch v-model="form.status"></el-switch>-->
<!--                    </el-col>-->
<!--                </el-form-item>-->
                <el-form-item label="销售码" prop="saleCode">
                    <el-col :span="8">
                        <el-input v-model="form.saleCode"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">
            <el-button type="primary" style="margin-bottom: 1rem" @click="showDialog" size="small">新建地址</el-button>
            <el-table
                    :data="addresses"
                    border
                    stripe
                    v-loading="loading"
                    style="width: 100%">
                <el-table-column
                        label="收货人姓名"
                >
                    <template scope="scope">
                        <el-input v-model="scope.row.name"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="联系电话"
                >
                    <template scope="scope">
                        <el-input v-model="scope.row.phone"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="配送地址">
                    <template scope="scope">
                        <el-input v-model="scope.row.address"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="送货时间">
                    <template scope="scope">
                        <el-input v-model="scope.row.remark"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="配送码">
                    <template scope="scope">
                        <el-input v-model="scope.row.deliveryCode"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template scope="scope">
                        <el-button type="primary" @click="onSubmitAddress(scope.row)">保存</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog
                title="提示"
                :visible.sync="submitAddressDialog"
                width="30%"
                center>
            <el-form ref="addressForm" :rules="addressRules" :model="addressForm" label-width="180px">
                <el-form-item label="收货人姓名：" prop="name">
                    <el-col :span="12">
                        <el-input v-model="addressForm.name"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="联系电话：" prop="phone">
                    <el-col :span="12">
                        <el-input v-model="addressForm.phone"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="配送地址：" prop="address">
                    <el-col :span="12">
                        <el-input v-model="addressForm.address"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="送货时间：" prop="remark">
                    <el-col :span="12">
                        <el-input v-model="addressForm.remark"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="配送码：" prop="deliveryCode">
                    <el-col :span="12">
                        <el-input v-model="addressForm.deliveryCode"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addAddress">保存</el-button>
                    <el-button @click="submitAddressDialog=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import Upload from "../../components/upload"
    import categoryApi from "../../api/category";
    import userApi from "../../api/user";
    import addressApi from "../../api/address";
    export default {
        data: function () {
            return {
                addresses: [],
                form: {
                    sort: 0,
                    // level: 1
                },
                addressForm: {
                },
                options: [],
                loading: false,
                submitAddressDialog: false,
                rules: {
                },
                addressRules: {
                    name: [ { type: 'string',required: true, message: "请输入收货人姓名", trigger: 'blur'}
                        // {max: 30,message: "名称长度不能超过30位" }
                        ],
                    // remark: [ { type: 'string',required: true,message: "请输入联系电话", trigger: 'blur'}],
                    phone: [ { type: 'string',required: true,message: "请输入联系电话", trigger: 'blur'}],
                    address: [ { type: 'string',required: true,message: "请输入配送地址", trigger: 'blur'}],
                    deliveryCode: [ { type: 'string',required: true,message: "请输入配送码", trigger: 'blur'}]
                }
            }
        },
        components: {Upload},
        mounted: function() {
            this.loadUser();
            this.loadAddresses();
        },
        methods: {
            addAddress: function() {
                this.$refs["addressForm"].validate(valid => {
                    if(!valid) return;
                    const loading = this.$loading({
                        lock: true,
                        text: '保存中',
                        spinner: 'el-icon-loading',
                    });
                    addressApi.add(this.addressForm, this.$route.query.id).then(result => {
                        loading.close();
                        this.submitAddressDialog = false;
                        this.$refs.addressForm.resetFields();
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        });

                        this.loadAddresses();
                    })
                })
            },
            showDialog: function() {
                this.submitAddressDialog = true;
            },
            loadUser: function() {
                userApi.findById(this.$route.query.id).then(result => {
                    this.form = {...result, status: result.status == 1 ? true : false};
                })
            },
            loadAddresses: function () {
                this.loading = true;
                addressApi.getByUserId(this.$route.query.id).then(result => {
                    this.loading = false;
                    this.addresses = result;
                })
            },
            onSubmit: function () {
                this.$refs["form"].validate(valid => {
                    if(!valid) return;
                    const loading = this.$loading({
                        lock: true,
                        text: '保存中',
                        spinner: 'el-icon-loading',
                    });
                    userApi.update(this.form).then(result => {
                        loading.close();
                        this.$message({
                            type: 'success',
                            message: '更新成功!'
                        });
                        this.$router.back();
                    })
                })

            },
            onSubmitAddress: function(row) {
                console.log(row)
                this.loading = true;
                addressApi.update(row).then(result => {
                    this.loading = false;
                    this.loadAddresses();
                })
            },
            onUploadSuccess: function (data) {
                this.form.pic = "/admin/file/download?fileId=" + data.id;
            },
            searchCategory: function (query) {
                if(query.length < 1) return;
                this.loading = true;
                categoryApi.search(query).then(options => {
                    this.loading = false;
                    this.options = options;
                })
            },
            loadRootCategories: function() {
                categoryApi.getChildren(0).then(data => {
                    this.rootCategories = data.map(e => ({value: e.id, label: e.name}));
                })
            },
        }
    }
</script>
